import React from 'react'
import { Support } from '../Icon'
import widgetStyles from './assets/widget.module.scss'

const LiveSupportPanel = () => (
  <div
    className={widgetStyles['content']}
  >
    <Support
      className={widgetStyles['assistant']}
    />

    <p>
      Live presenter support chat is available from 30&nbsp;minutes before the live webinar and throughout the live duration.
      Except for public holidays, live presenter support chat is available Monday to Friday for webinars starting between:
    </p>

    <ul className={widgetStyles['regions']}>
      <li>
        <p>United Kingdom - London</p>
        <p>8:00am - 5:00pm</p>
      </li>
      <li>
        <p>United States - New York</p>
        <p>8:00am - 5:00pm</p>
      </li>
      <li>
        <p>United States - Los Angeles</p>
        <p>8:00am - 4:00pm</p>
      </li>
      <li>
        <p>Australia - Sydney</p>
        <p>9:00am - 5:00pm</p>
      </li>
    </ul>

    <p>Need assistance now?</p>
    <a
      className={widgetStyles['support']}
      href="mailto:support@brighttalk.com"
      data-bdd="live-support-link">
      support@brighttalk.com
    </a>

  </div>

)

export default LiveSupportPanel
